import React from 'react';

import { Stack } from '@mui/material';

import AccommodationPropertyRoomsResultsTable from './AccommodationPropertyRoomsResultsTable';

interface Props {
  rowClickAction?: 'modal' | 'navigate';
}

export default function AccommodationPropertyRoomsSection({ rowClickAction = 'modal' }: Props) {
  return (
    <Stack direction="column" gap={4}>
      <AccommodationPropertyRoomsResultsTable rowClickAction={rowClickAction} />
    </Stack>
  );
}
